/* unplugin-vue-components disabled */import script from "./information.vue?vue&type=script&lang=jsx"
export * from "./information.vue?vue&type=script&lang=jsx"

import "./information.vue?vue&type=style&index=0&id=00fa03ac&lang=less&scoped=true"

import exportComponent from "/data1/jenkins/master_project/website-sszx/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-00fa03ac"]])

export default __exports__